import { fetchFactory } from 'Libs/http/utils';
import { getCurrentBOLanguageOrDefault } from 'Services/language/languageService';

export const getCoursesOptions = async () => {
  const { languageCode } = getCurrentBOLanguageOrDefault();

  console.log('languageCode', languageCode);

  const { fetchFn } = fetchFactory<{ id: number; title: string }[]>({
    route: '/api/courses/options',
    method: 'GET',
    query: {
      locale: languageCode,
    },
  });
  return fetchFn();
};
